import {Utils} from "../../utils.js";
import {MeasurePanel} from "./MeasurePanel.js";

export class ConvexVolumePanel extends MeasurePanel {
	constructor(viewer, measurement, propertiesPanel) {
		super(viewer, measurement, propertiesPanel);
		let removeIconPath = Potree.resourcePath + '/icons/remove.svg';
		this.elContent = $(`
			<div class="measurement_content selectable">
				<span class="coordinates_table_container"></span><br>
				<span style="font-weight: bold">Volume: </span>
				<span id="measurement_volume"></span>
				<div style="display: flex; margin-top: 12px">
					<span></span><span style="flex-grow: 1"></span>
					<img name="remove" class="button-icon" src="${removeIconPath}" style="width: 16px; height: 16px"/>
				</div>
			</div>`);
		this.elContent.find("img[name=remove]").click(() => viewer.scene.removeMeasurement(measurement));
		for (const event of ["marker_added", "marker_removed", "marker_moved", "convex_volume_changed"]) {
			propertiesPanel.addVolatileListener(measurement, event, this._update);
		}
		this.update();
	}

	update() {
		let container = this.elContent.find('.coordinates_table_container');
		container.empty().append(this.createCoordinatesTable(this.measurement.points.map(p => p.position)));
		let volumeText = typeof this.measurement.getFormattedVolume === 'function'
			? this.measurement.getFormattedVolume()
			: `${Utils.addCommas(this.measurement.getVolume().toFixed(3))} m³`;
		this.elContent.find('#measurement_volume').text(volumeText);
	}
}
